/**
 * this file should contain all dispatch constants used in global actions and reducers
 */

// Root actions
export const SET_PLAN_DETAILS = 'Root/SET_PLAN_DETAILS';

// Auth actions
export const AUTH_INITIALIZE = 'auth/AUTH_INITIALIZE';
export const AUTH_INITIALIZE_DONE = 'auth/AUTH_INITIALIZE_DONE';

export const AUTH_LOGIN_REQUEST = 'auth/AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_SUCCESS = 'auth/AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'auth/AUTH_LOGIN_FAILURE';

export const AUTH_TWO_FACTOR = 'auth/AUTH_TWO_FACTOR';

export const AUTH_CLEAR_DATA = 'auth/AUTH_CLEAR_DATA';
export const AUTH_CLEAR_ERROR = 'auth/AUTH_CLEAR_ERROR';

export const AUTH_TWO_FACTOR_TIMEOUT = 'auth/AUTH_TWO_FACTOR_TIMEOUT';
export const AUTH_TWO_FACTOR_TIMEOUT_ERROR = 'Took to long to enter two factor code. Please log in again';

// Set/Reset password actions
export const MANAGE_PASSWORD_REQUEST = 'ManagePasswordActions/MANAGE_PASSWORD_REQUEST';
export const MANAGE_PASSWORD_SUCCESS = 'ManagePasswordActions/MANAGE_PASSWORD_SUCCESS';
export const MANAGE_PASSWORD_FAILURE = 'ManagePasswordActions/MANAGE_PASSWORD_FAILURE';
export const MANAGE_PASSWORD_CLEAR_ERROR = 'ManagePasswordActions/MANAGE_PASSWORD_CLEAR_ERROR';
export const MANAGE_PASSWORD_CLEAR_STATE = 'ManagePasswordActions/MANAGE_PASSWORD_CLEAR_STATE';

// Sign up actions
export const SIGNUP_REQUEST = 'SignupPage/SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SignupPage/SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SignupPage/SIGNUP_FAILURE';
export const SIGNUP_CLEAR_ERROR = 'SignupPage/CLEAR_ERROR';
export const SIGNUP_CLEAR_STATE = 'SignupPage/CLEAR_STATE';
